import { EvScreenshotService, ScreenshotDetails } from '@evinced-private/ui-common';

export type { ScreenshotDetails };

export const screenshotService = new EvScreenshotService({
	scale: 0.5
});
